module.exports = __webpack_public_path__ + "img/61.de355642.jpg";